'use client';

import ServiceCard from './ServiceCard';
import ComparisonMatrix from './ComparisonMatrix';
import SeasonalRecommendations from './SeasonalRecommendations';
import ServiceCalculator from './ServiceCalculator';

interface Service {
  id: string;
  title: string;
  description: string;
  image: string;
  alt: string;
  benefits: string[];
  frequency: string;
  icon: string;
  features: {
    duration: string;
    frequency: string;
    difficulty: string;
    season: string;
  };
}

interface GalleryItem {
  id: string;
  service: string;
  before: {
    image: string;
    alt: string;
  };
  after: {
    image: string;
    alt: string;
  };
  customerName: string;
  location: string;
}

interface Season {
  name: string;
  months: string;
  icon: string;
  color: string;
  recommendations: Array<{
    service: string;
    priority: 'High' | 'Medium' | 'Low';
    reason: string;
  }>;
}

interface ServiceOption {
  id: string;
  name: string;
  basePrice: number;
}

interface ServicesInteractiveProps {
  services: Service[];
  galleryItems: GalleryItem[];
  seasons: Season[];
  serviceOptions: ServiceOption[];
}

export default function ServicesInteractive({
  services,
  galleryItems,
  seasons,
  serviceOptions,
}: ServicesInteractiveProps) {
  return (
    <>
      <section className="mb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </section>

      <section className="mb-16">
        <ComparisonMatrix services={services} />
      </section>

      <section className="mb-16">
        <SeasonalRecommendations seasons={seasons} />
      </section>

      <section className="mb-16 -mx-4 sm:-mx-6 lg:-mx-8">
        <div className="px-4 sm:px-6 lg:px-8">
          <ServiceCalculator services={serviceOptions} />
        </div>
      </section>
    </>
  );
}